export default __webpack_public_path__ + "static/media/ranes2.f92b2a53.jpg";